import { Colors } from '@estee/elc-base-theme';

export const SelectedSwatchTheme = `
    border: 2px solid ${Colors.black}
`;

export const VtoShadeGridContainerTheme = `
    background: ${Colors.white};
`;
